












import { Component, Vue } from 'vue-property-decorator';
import Footprints from './Footprints.vue';

@Component({
  components: {
    Footprints,
  },
})
export default class FootprintsWrapper extends Vue {
  characters = [
    'boromir',
    'legolasGimli',
    'aragorn',
    'gandalf',
    'merryPippin',
    'frodoSam',
  ];
}
